<template>
  <div class="flex items-center justify-center w-8 shrink-0">
    <span v-if="change > 0" class="flex items-center gap-0.5 text-success text-xs font-bold">
      <i class="mdi mdi-arrow-up text-sm leading-none"></i>
      <FlipValue :display="change" :value-key="change" />
    </span>
    <span v-else-if="change < 0" class="flex items-center gap-0.5 text-error text-xs font-bold">
      <i class="mdi mdi-arrow-down text-sm leading-none"></i>
      <FlipValue :display="Math.abs(change)" :value-key="change" />
    </span>
    <span v-else class="text-base-content/20 text-sm">—</span>
  </div>
</template>

<script setup>
import FlipValue from './FlipValue.vue'

defineProps({
  change: {
    type: Number,
    required: true,
  },
})
</script>
